<template>
  <div>
    <PageAllow
      controller="PurchasePlans"
      action="getAutoRuler"
    />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{$t("PurchasePlans.actions.autoRuler")}}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="$router.push('/purchase-plans')"
              >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("Nav.purchasePlans")]) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <v-container>
            <ValidationObserver ref="observer">
              <!-- 自动生成时间段 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("PurchasePlans.autoRuler.auto_time") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-data-table
                    :headers="defaultTimeHeaders"
                    :items="timesData"
                    multi-sort
                    class="elevation-1 px-4 pt-2"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:header.actions>
                      <!-- 删除按钮 -->
                      <v-btn
                        small
                        text
                        class="danger--text pa-0"
                        @click="timesData = []"
                      >
                        <v-icon>fa-times</v-icon>
                      </v-btn>
                    </template>
                    <template v-slot:item.orderEndTime="{ item }">
                      <v-checkbox
                        class="mt-2 mb-n2 ml-3"
                        color="primary"
                        v-model="item.orderEndTime"
                        :true-value="item.value"
                        :false-value="0"
                        @change="resetCheckbox(item.orderEndTime)"
                      >
                      </v-checkbox>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <!-- 删除按钮 -->
                      <v-btn
                        small
                        text
                        class="danger--text pa-0"
                        @click="
                          timesData.splice(
                            timesData.findIndex(
                              (data) => data.value == item.value
                            ),
                            1
                          )
                        "
                      >
                        <v-icon>fa-times</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
                <v-col cols="3"></v-col>
                <v-col cols="9" md="7">
                  <v-btn
                    color="primary"
                    class="my-1 mr-3"
                    x-small
                    outlined
                    @click="addDialog = true;addType = 1"
                  >
                    {{ $t("PurchasePlans.autoRuler.add_dialog_title") }}
                  </v-btn>
                </v-col>
              </v-row>
              <!-- 出库单时间范围类型 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("PurchasePlans.autoRuler.date_type") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-radio-group row v-model="autoRuler.date_type">
                    <v-radio
                      :label="$t('StockOrderOUT.Fields.order_time')"
                      :key="1"
                      :value="1"
                    />
                    <v-radio
                      :label="$t('StockOrderOUT.Fields.created_time')"
                      :key="2"
                      :value="2"
                    />
                    <v-radio
                      :label="$t('StockOrderOUT.Fields.actual_time')"
                      :key="3"
                      :value="3"
                    />
                    <v-radio
                      :label="$t('StockOrderOUT.Fields.expect_time')"
                      :key="4"
                      :value="4"
                    />
                  </v-radio-group>
                </v-col>
              </v-row>
              <!-- 出库单时间范围天数 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("PurchasePlans.autoRuler.date_day") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-text-field
                    v-model="autoRuler.date_day"
                    dense
                    single-line
                    suffix="天"
                    type="number"
                    style="max-width: 150px"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <!-- 短信地址 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("PurchasePlans.autoRuler.sms") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-data-table
                    :headers="defaultHeaders"
                    :items="smsData"
                    multi-sort
                    class="elevation-1 px-4 pt-2"
                    disable-pagination
                    hide-default-header
                    hide-default-footer
                    fixed-header
                  >
                    <template v-slot:item.actions="{ item }">
                      <!-- 删除按钮 -->
                      <v-btn
                        small
                        text
                        class="danger--text pa-0"
                        @click="
                          smsData.splice(
                            smsData.findIndex(
                              (data) => data.value == item.value
                            ),
                            1
                          )
                        "
                      >
                        <v-icon>fa-times</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
                <v-col cols="3"></v-col>
                <v-col cols="9" md="7">
                  <v-btn
                    color="primary"
                    class="my-1 mr-3"
                    x-small
                    outlined
                    @click="addDialog = true;addType = 2"
                  >
                    {{ $t("PurchasePlans.autoRuler.add_dialog_title") }}
                  </v-btn>
                </v-col>
              </v-row>
              <!-- 邮件地址 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("PurchasePlans.autoRuler.emails") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-data-table
                    :headers="defaultHeaders"
                    :items="emailData"
                    multi-sort
                    class="elevation-1 px-4 pt-2"
                    disable-pagination
                    hide-default-header
                    hide-default-footer
                    fixed-header
                  >
                    <template v-slot:item.actions="{ item }">
                      <!-- 删除按钮 -->
                      <v-btn
                        small
                        text
                        class="danger--text pa-0"
                        @click="
                          emailData.splice(
                            emailData.findIndex(
                              (data) => data.value == item.value
                            ),
                            1
                          )
                        "
                      >
                        <v-icon>fa-times</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
                <v-col cols="3"></v-col>
                <v-col cols="9" md="7">
                  <v-btn
                    color="primary"
                    class="my-1 mr-3"
                    x-small
                    outlined
                    @click="addDialog = true;addType = 3"
                  >
                    {{ $t("PurchasePlans.autoRuler.add_dialog_title") }}
                  </v-btn>
                </v-col>
              </v-row>
              <!-- 是否减库存值 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("PurchasePlans.autoRuler.is_stock_current") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-radio-group row v-model="autoRuler.is_stock_current">
                    <v-radio
                      :label="$t('PurchasePlans.actions.on')"
                      :key="1"
                      :value="1"
                    />
                    <v-radio
                      :label="$t('PurchasePlans.actions.off')"
                      :key="0"
                      :value="0"
                    />
                  </v-radio-group>
                </v-col>
              </v-row>
              <!-- 是否计算损耗 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("PurchasePlans.autoRuler.is_loss") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-radio-group row v-model="autoRuler.is_loss">
                    <v-radio
                      :label="$t('PurchasePlans.actions.on')"
                      :key="1"
                      :value="1"
                    />
                    <v-radio
                      :label="$t('PurchasePlans.actions.off')"
                      :key="0"
                      :value="0"
                    />
                  </v-radio-group>
                </v-col>
              </v-row>
              <!-- 是否减在途值 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("PurchasePlans.autoRuler.is_purchased") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-radio-group row v-model="autoRuler.is_purchased">
                    <v-radio
                      :label="$t('PurchasePlans.actions.on')"
                      :key="1"
                      :value="1"
                    />
                    <v-radio
                      :label="$t('PurchasePlans.actions.off')"
                      :key="0"
                      :value="0"
                    />
                  </v-radio-group>
                </v-col>
              </v-row>
              <!-- 是否自动分配 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("PurchasePlans.autoRuler.is_distribute") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-radio-group row v-model="autoRuler.is_distribute">
                    <v-radio
                      :label="$t('PurchasePlans.actions.on')"
                      :key="1"
                      :value="1"
                    />
                    <v-radio
                      :label="$t('PurchasePlans.actions.off')"
                      :key="0"
                      :value="0"
                    />
                  </v-radio-group>
                </v-col>
              </v-row>
              <!-- 上游品牌端发货自动入库 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("PurchasePlans.autoRuler.auto_in") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-radio-group row v-model="autoRuler.auto_in">
                    <v-radio
                      :label="$t('PurchasePlans.actions.on')"
                      :key="1"
                      :value="1"
                    />
                    <v-radio
                      :label="$t('PurchasePlans.actions.off')"
                      :key="0"
                      :value="0"
                    />
                  </v-radio-group>
                </v-col>
              </v-row>
              <!-- 选择仓库 -->
              <v-row class="mt-10">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("Stock.ObjectName") }}{{ $t("Global.colon") }}
                  <Required :show="true" mode="edit" />
                  <br />
                  <v-btn
                    color="primary"
                    class="my-1 mr-3"
                    x-small
                    outlined
                    @click="stocksDialog = true"
                  >
                    {{ $t("CRUD.chooseInfo", [$t("Stock.ObjectName")]) }}
                  </v-btn>
                </v-col>
                <v-col cols="9" md="7">
                  <v-data-table
                    :headers="stockHeaders"
                    :items="stocks"
                    multi-sort
                    class="elevation-1 px-4 pt-2"
                    disable-pagination
                    hide-default-footer
                    fixed-header
                  >
                    <template v-slot:header.actions>
                      <!-- 删除按钮 -->
                      <v-btn
                        small
                        text
                        class="danger--text pa-0"
                        @click="stocks = []"
                      >
                        <v-icon>fa-times</v-icon>
                      </v-btn>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <!-- 删除商品按钮 -->
                      <v-btn
                          small
                          text
                          class="danger--text pa-0"
                          @click="
                          stocks.splice(
                            stocks.findIndex(
                              (stock) => stock.id == item.id
                            ),
                            1
                          )
                        "
                      >
                        <v-icon>fa-times</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <!-- 选择供应商 -->
              <v-row class="mt-10">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("Supplier.ObjectName") }}{{ $t("Global.colon") }}
                  <Required :show="true" mode="edit" />
                  <br />
                  <v-btn
                    color="primary"
                    class="my-1 mr-3"
                    x-small
                    outlined
                    @click="suppliersDialog = true"
                  >
                    {{ $t("CRUD.chooseInfo", [$t("Supplier.ObjectName")]) }}
                  </v-btn>
                </v-col>
                <v-col cols="9" md="7">
                  <v-data-table
                    :headers="supplierHeaders"
                    :items="suppliers"
                    multi-sort
                    class="elevation-1 px-4 pt-2"
                    disable-pagination
                    hide-default-footer
                    fixed-header
                  >
                    <template v-slot:header.actions>
                      <!-- 删除按钮 -->
                      <v-btn
                        small
                        text
                        class="danger--text pa-0"
                        @click="suppliers = []"
                      >
                        <v-icon>fa-times</v-icon>
                      </v-btn>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <!-- 删除商品按钮 -->
                      <v-btn
                          small
                          text
                          class="danger--text pa-0"
                          @click="
                          suppliers.splice(
                            suppliers.findIndex(
                              (supplier) => supplier.id == item.id
                            ),
                            1
                          )
                        "
                      >
                        <v-icon>fa-times</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <!-- 选择商品 -->
<!--              <v-row class="mt-10">-->
<!--                <v-col cols="3" class="font-weight-bold text-right">-->
<!--                  {{ $t("MaterialOrderRule.Fields.material")-->
<!--                  }}{{ $t("Global.colon") }}-->
<!--                  <Required :show="true" mode="edit" />-->
<!--                  <br />-->
<!--                  <v-btn-->
<!--                    color="primary"-->
<!--                    class="my-1 mr-3"-->
<!--                    x-small-->
<!--                    outlined-->
<!--                    @click="materialsDialog = true"-->
<!--                  >-->
<!--                    {{-->
<!--                      $t("CRUD.chooseInfo", [-->
<!--                        $t("MaterialOrderRule.Fields.material"),-->
<!--                      ])-->
<!--                    }}-->
<!--                  </v-btn>-->
<!--                </v-col>-->
<!--                <v-col cols="9" md="7">-->
<!--                  <v-data-table-->
<!--                    :headers="materialHeaders"-->
<!--                    :items="materials"-->
<!--                    multi-sort-->
<!--                    class="elevation-1 px-4 pt-2"-->
<!--                    disable-pagination-->
<!--                    hide-default-footer-->
<!--                    fixed-header-->
<!--                  >-->
<!--                    <template v-slot:header.actions>-->
<!--                      &lt;!&ndash; 删除按钮 &ndash;&gt;-->
<!--                      <v-btn-->
<!--                        small-->
<!--                        text-->
<!--                        class="danger&#45;&#45;text pa-0"-->
<!--                        @click="materials = []"-->
<!--                      >-->
<!--                        <v-icon>fa-times</v-icon>-->
<!--                      </v-btn>-->
<!--                    </template>-->
<!--                    <template v-slot:item.actions="{ item }">-->
<!--                      &lt;!&ndash; 删除商品按钮 &ndash;&gt;-->
<!--                      <v-btn-->
<!--                          small-->
<!--                          text-->
<!--                          class="danger&#45;&#45;text pa-0"-->
<!--                          @click="-->
<!--                          materials.splice(-->
<!--                            materials.findIndex(-->
<!--                              (material) => material.id == item.id-->
<!--                            ),-->
<!--                            1-->
<!--                          )-->
<!--                        "-->
<!--                      >-->
<!--                        <v-icon>fa-times</v-icon>-->
<!--                      </v-btn>-->
<!--                    </template>-->
<!--                  </v-data-table>-->
<!--                </v-col>-->
<!--              </v-row>-->
            </ValidationObserver>
          </v-container>
        </v-card-text>
      </v-card>
      <v-sheet class="page-opts">
        <v-card>
          <v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-btn
                  outlined
                  color="secondary"
                  class="elevation-1"
                  block
                  href="/#/purchase-plans"
                >
                  <v-icon small class="pe-1">fa-times</v-icon>
                  {{ $t("CRUD.backToList", [$t("Nav.purchasePlans")]) }}
                </v-btn>
              </v-col>
              <v-col
                  cols="12"
                  v-if="$permission.permissionAllow(
                    'PurchasePlans',
                    'saveAutoRuler'
                    )
                  "
              >
                <v-btn
                  color="success"
                  block
                  @click="doSubmit()"
                >
                  <v-icon small class="pe-1">fa-save</v-icon>
                  {{ $t("CRUD.saveInfo", [$t("PurchasePlans.actions.autoRuler")]) }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-sheet>
    </v-sheet>
    <AddDialog
      v-model="addDialog"
      :type="addType"
      @add="
        addDialog = false;
        addData($event)
      "
    />
<!--    <MaterialsSelectsDialog-->
<!--      v-model="materialsDialog"-->
<!--      :materialIds="materialIds"-->
<!--      @confirm="choosedMaterials = $event"-->
<!--    />-->
    <SuppliersSelectsDialog
      v-model="suppliersDialog"
      :supplierIds="supplierIds"
      @confirm="choosedSuppliers = $event"
    />
    <StocksSelectsDialog
      v-model="stocksDialog"
      :stockIds="stockIds"
      :types="[0]"
      :status="[1]"
      @confirm="choosedStocks = $event"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import {ValidationObserver} from "vee-validate";
import Required from "@/components/plugins/Required.vue";
import PurchasePlans from "@/api/purchase_plans.js";
import StocksSelectsDialog from "@/components/plugins/StocksSelectsDialog";
import SuppliersSelectsDialog from "@/components/plugins/SuppliersSelectsDialog";
// import MaterialsSelectsDialog from "@/components/plugins/MaterialsSelectsDialog";
import Stocks from "@/api/stocks";
import Suppliers from "@/api/suppliers";
// import Materials from "@/api/materials";
import AddDialog from "./plugins/AddDialog.vue";

export default {
  components: {
    Required,
    ValidationObserver,
    // ValidationProvider,
    PageAllow,
    Breadcrumbs,
    StocksSelectsDialog,
    SuppliersSelectsDialog,
    // MaterialsSelectsDialog,
    AddDialog,
  },
  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.purchases"),
        disabled: false,
        href: "/purchases",
      },
      {
        text: i18n.t("Nav.purchasePlans"),
        disabled: false,
        href: "/purchase-plans",
      },
      {
        text: i18n.t("PurchasePlans.actions.autoRuler"),
        disabled: true,
        href: "/purchase-plans/auto-ruler",
      },
    ],
    defaultTimeHeaders: () => [
      {
        text: i18n.t("PurchasePlans.autoRuler.time_math"),
        align: "start",
        sortable: false,
        value: "value",
      },
      {
        text: i18n.t("PurchasePlans.autoRuler.order_end_time"),
        align: "start",
        sortable: false,
        value: "orderEndTime",
        width: 100
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "center",
        sortable: false,
        value: "actions",
        width: 100,
      }
    ],
    defaultHeaders: () => [
      {
        text: i18n.t("MaterialOrderRule.Fields.material_name"),
        align: "start",
        sortable: false,
        value: "value",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "end",
        sortable: false,
        value: "actions",
      }
    ],
    materialHeaders: () => [
      {
        text: i18n.t("MaterialOrderRule.Fields.material_code"),
        align: "start",
        sortable: false,
        value: "material_code",
      },
      {
        text: i18n.t("MaterialOrderRule.Fields.material_name"),
        align: "start",
        sortable: false,
        value: "material_name",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "end",
        sortable: false,
        value: "actions",
      }
    ],
    supplierHeaders: () => [
      {
        text: i18n.t("Supplier.Fields.supplier_code"),
        align: "start",
        sortable: false,
        value: "supplier_code",
      },
      {
        text: i18n.t("Supplier.Fields.supplier_name"),
        align: "start",
        sortable: false,
        value: "supplier_name",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "end",
        sortable: false,
        value: "actions",
      }
    ],
    stockHeaders: () => [
      {
        text: i18n.t("Stock.Fields.stock_code"),
        align: "start",
        sortable: false,
        value: "code",
      },
      {
        text: i18n.t("Stock.Fields.stock_name"),
        align: "start",
        sortable: false,
        value: "name",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "end",
        sortable: false,
        value: "actions",
      }
    ],
    ...mapState(["settings", "loading"]),
  },

  data: () => ({
    autoRuler: [],
    addType: null,
    timesData: [],
    order_end_time: "",
    smsData: [],
    emailData: [],
    addDialog: false,
    stocksDialog: false,
    stocks: [],
    stockIds: [],
    choosedStocks: [], //每次选中的仓库
    suppliersDialog: false,
    suppliers: [],
    supplierIds: [],
    choosedSuppliers: [], //每次选中的供应商
    materialsDialog: false,
    materials: [],
    materialIds: [],
    choosedMaterials: [], //每次选中的商品
  }),

  mounted() {
    this.getAutoRulerFromAPI()
  },

  methods: {
    addData(data) {
      if (!data) {
        return
      }
      if (this.addType == 1) {
        // 自动生成时间段
        // 检测数据是否存在
        if (this.timesData.find((value) => value.value == data)) {
          return;
        }
        this.timesData.push({
          value:data,
          orderEndTime: 0
        })
      }
      if (this.addType == 2) {
        // 短信
        // 检测数据是否存在
        if (this.smsData.find((value) => value.value == data)) {
          return;
        }
        this.smsData.push({
          value:data
        })
      }
      if (this.addType == 3) {
        // 邮件
        // 检测数据是否存在
        if (this.emailData.find((value) => value.value == data)) {
          return;
        }
        this.emailData.push({
          value:data
        })
      }
    },
    getAutoRulerFromAPI() {
      PurchasePlans.getAutoRuler().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.autoRuler = Object.assign(
                response.data.auto_ruler,
                response.data.auto_ruler.conditions
            );
            this.autoRuler.times.map((time) => {
              this.timesData.push({value: time, orderEndTime: time == this.autoRuler.order_end_time ? this.autoRuler.order_end_time : 0})
            })
            this.autoRuler.sms.map((time) => {
              this.smsData.push({value: time})
            })
            this.autoRuler.emails.map((time) => {
              this.emailData.push({value: time})
            })
            this.getStocksFromApi()
            this.getSuppliersFromApi()
            // this.getMaterialsFromApi()
          }
        }.bind(this)
      );
    },
    getStocksFromApi() {
      let fieldFilter = [
        "id",
        "code",
        "name",
        "type",
        "status",
        "StockDistrict.id"
      ];
      let options = Object.assign(
          {
            fieldFilter: fieldFilter,
            stock_ids: this.autoRuler.stock_ids
            // 仅筛选少许必要字段
          },
          this.options
      );
      Stocks.fetchAllNoPaging(options).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.stocks = response.data.stocks.map((stock) => {
                stock.choose = 1;
                return stock;
              });
            }
          }.bind(this)
      );
    },
    getSuppliersFromApi() {
      let fieldFilter = [
        "id",
        "supplier_code",
        "supplier_name",
        "stop_flg",
        "manager_name",
        "manager_tel",
      ];
      let options = Object.assign(
          {
            fieldFilter: fieldFilter,
            supplier_ids: this.autoRuler.supplier_ids
            // 仅筛选少许必要字段
          },
          this.options
      );
      Suppliers.fetchAllNoPaging(options).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.suppliers = response.data.suppliers.map((supplier) => {
                supplier.choose = 1;
                return supplier;
              });
            }
          }.bind(this)
      );
    },
    // getMaterialsFromApi() {
    //   let fieldFilter = [
    //     "id",
    //     "material_code",
    //     "material_name",
    //     "public_flg",
    //   ];
    //   let options = Object.assign(
    //       {
    //         fieldFilter: fieldFilter,
    //         material_ids: this.autoRuler.material_ids
    //         // 仅筛选少许必要字段
    //       },
    //       this.options
    //   );
    //   Materials.fetchAllNoPaging(options).then(
    //       function (response) {
    //         if (response.data.status.isOK()) {
    //           this.materials = response.data.materials.map((material) => {
    //             material.choose = 1;
    //             return material;
    //           });
    //         }
    //       }.bind(this)
    //   );
    // },
    //整理预览提交数据
    doSubmitData() {
      let postData = {
        id: this.autoRuler.id,
        time_type: 1,
        times: this.timesData.map((data) => {return data.value}),
        order_end_time: this.order_end_time,
        date_type: this.autoRuler.date_type,
        date_day: this.autoRuler.date_day,
        sms: this.smsData.map((data) => {return data.value}),
        emails: this.emailData.map((data) => {return data.value}),
        is_distribute: this.autoRuler.is_distribute,
        auto_in: this.autoRuler.auto_in,
        is_loss: this.autoRuler.is_loss,
        is_purchased: this.autoRuler.is_purchased,
        is_stock_current: this.autoRuler.is_stock_current,
        stock_ids: this.stockIds,
        supplier_ids: this.supplierIds,
        // material_ids: this.materialIds,
      }
      return postData;
    },
    doSubmit() {
      if (this.supplierIds.length == 0) {
        this.$snackbar.error(i18n.t("PurchasePlans.autoRuler.supplier_error"));
        return;
      }
      // if (this.materialIds.length == 0) {
      //   this.$snackbar.error(i18n.t("PurchasePlans.autoRuler.material_error"));
      //   return;
      // }
      this.$store.dispatch("fullscreenLoading");
      PurchasePlans.saveAutoRuler(this.doSubmitData()).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$snackbar.success(i18n.t("PurchasePlans.autoRuler.save_success"));
            this.$router.push("/purchase-plans");
            this.$store.dispatch("fullscreenLoadingStop");
          }else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
         }.bind(this)
      )
      .catch(
        function () {
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      );
    },
    resetCheckbox(data) {
      this.order_end_time = "";
      this.timesData.forEach((time) => {
        if (time.value != data) {
          time.orderEndTime = 0
        }else {
          this.order_end_time = data
        }
      });
    },
  },

  watch: {
    // 监听单次选择的仓库
    choosedStocks: {
      handler() {
        //  综合多次选择的供应商
        this.choosedStocks.map((stock) => {
          this.stocks.push(stock)
        });
      },
    },
    stocks: {
      deep: true,
      handler() {
        if (this.stocks.length) {
          this.stockIds = this.stocks.map((stock) => {
            return stock.id;
          });
        } else {
          this.stockIds = [];
        }
      },
    },
    // 监听单次选择的供应商
    choosedSuppliers: {
      handler() {
        //  综合多次选择的供应商
        this.choosedSuppliers.map((supplier) => {
          this.suppliers.push(supplier)
        });
      },
    },
    suppliers: {
      deep: true,
      handler() {
        if (this.suppliers.length) {
          this.supplierIds = this.suppliers.map((supplier) => {
            return supplier.id;
          });
        } else {
          this.supplierIds = [];
        }
      },
    },
    // // 监听单次选择的商品
    // choosedMaterials: {
    //   handler() {
    //     //  综合多次选择的商品
    //     this.choosedMaterials.map((material) => {
    //       this.materials.push(material)
    //     });
    //   },
    // },
    // materials: {
    //   deep: true,
    //   handler() {
    //     if (this.materials.length) {
    //       this.materialIds = this.materials.map((material) => {
    //         return material.id;
    //       });
    //     } else {
    //       this.materialIds = [];
    //     }
    //   },
    // },
  },
};
</script>